// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"454":"0b6308ac","753":"0d7de7a0"}[chunkId] + ".css";
};